import type { IRequestOptions, IValidatedResponse } from '../../httpClient';
import { getRequest } from '../../httpClient';
import type { IListReviewerPerformanceRecentChallengesV1Query } from './list-reviewer-performance-recent-challenges-v1-request';
import type { IListReviewerPerformanceRecentChallengesV1Response } from './list-reviewer-performance-recent-challenges-v1-response';
import { listReviewerPerformanceRecentChallengesV1ResponseSchema } from './list-reviewer-performance-recent-challenges-v1-response';

export async function listReviewerPerformanceRecentChallengesV1Api(
  query: IListReviewerPerformanceRecentChallengesV1Query,
  options?: IRequestOptions,
): Promise<IValidatedResponse<IListReviewerPerformanceRecentChallengesV1Response>> {
  const params = new URLSearchParams();
  params.set('userId', query.userId);
  if (query.limit != null) {
    params.set('limit', String(query.limit));
  }
  return getRequest<IListReviewerPerformanceRecentChallengesV1Response>({
    path: `/sys/reviewer-performance/v1/recent-challenges?${params.toString()}`,
    schema: listReviewerPerformanceRecentChallengesV1ResponseSchema,
    options,
  });
}
